// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  // parse: {
  //   name: "dev",
  //   appId: "WB_API",
  //   jsKey: "javascriptKey",
  //   apiUrl: "https://dev-api.wattbike.com/v2",
  //   hubUrl: "https://dev-hub.wattbike.com",
  //   authUrl: "https://dev-auth.wattbike.com",
  //   authClientId: "7i11a51i1s0735po0knubqq2dp",
  // },
  parse: {
    name: "qa",
    appId: "WB_API",
    jsKey: "javascriptKey",
    apiUrl: "https://qa-api.wattbike.com/v2",
    hubUrl: "https://dev-hub.wattbike.com",
    authUrl: "https://qa-auth.wattbike.com",
    authClientId: "14d7j8c2f7m8mggicpo11bsmvo",
  },
  // parse: {
  //   name: "prod",
  //   appId: "Gopo4QrWEmTWefKMXjlT6GAN4JqafpvD",
  //   jsKey: "p1$h@M10Tkzw#",
  //   apiUrl: "https://api.wattbike.com/v2",
  //   hubUrl: "https://hub.wattbike.com",
  //   authUrl: "https://auth.wattbike.com",
  //   authClientId: "2o35ocqkd3i7al5umvie51dc99",
  // },
  createSend: {
    clientId: "0d4bd4bbeeb78036345d1b3f1c022fd1",
    apiKey: "NWI3ZDUxN2MzZGNjZDcyMzgzYWNkMWUzMjQ1ZGI1NGE5ZDM4NWQ1M2IxY2Q3MDJlOng=",
    defaultList: "aa7a6aefe6192764bea660eb4a9987ea"
  }
};



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/environments/environment.ts